export default __webpack_public_path__ + "static/media/main-3.3e30c102.jpg";